import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { Text } from './style'

export const AGBModal = () => {
  const agbText = useMySelector((state) => state.app.interfaceStyles.agbText)

  return (
    <div>
      <Text>{agbText}</Text>
    </div>
  )
}
